import { useSignupStore } from "components/Signup/store/hooks";
import { useEffect } from "react";
import { stateStore } from "../utils/stateStore";

export function useStateStore() {
  const { subscribe, getState } = useSignupStore();

  useEffect(() => {
    const unsubscribe = subscribe(() => {
      const { metadata, customer, animals, navigation } = getState();

      stateStore.save({
        metadata: {
          ...metadata,
          error: null,
          loading: false,
        },
        customer,
        animals,
        navigation: {
          activeStep: navigation.activeStep,
        },
      });
    });

    return () => unsubscribe();
  }, [getState, subscribe]);
}
